<!-- logo -->
<df-base-logo *ngIf="!userService.User?.isSemrushPlan()"></df-base-logo>

<!-- menu items -->
<div class="menu-sections overflow-y-hidden flex flex-col justify-between h-full w-full relative">
  <df-base-left-side-navigation-menu class="overflow-y-auto no-scroll-bar"></df-base-left-side-navigation-menu>
  <df-base-left-side-navigation-footer></df-base-left-side-navigation-footer>
</div>

<!-- menu toggle - desktop -->
<div
  (click)="toggleNavigation()"
  class="hide rounded-full cursor-pointer w-6 h-6 tui-primary-bg absolute top-12 -right-3 flex z-50 items-center justify-center tui-base-01"
>
  <svg-icon
    [src]="basePanelService.routeData.shortLeftNavigation ? '/assets/img/Forward.svg' : '/assets/img/Back.svg'"
    [svgStyle]="{ width: '1rem', height: '1rem' }"
  ></svg-icon>
</div>

<!-- menu burger - mobile -->
<div
  class="menu-burger"
  (click)="toggleMobileNavigation()"
  [class.menu-hidden]="!openMobileNavigation"
>
  <svg-icon
    [src]="'/assets/img/fi_menu.svg'"
    *ngIf="!openMobileNavigation"
  ></svg-icon>
  <svg-icon
    [src]="'/assets/img/Close.svg'"
    *ngIf="openMobileNavigation"
    class="tui-base-01"
  ></svg-icon>
</div>
